var filterByPromotion = function filterByPromotion(obj) {
  if ('slug' in obj && obj.slug === 'promotion') {
    return true;
  }
  return false;
};
export default filterByPromotion;